import { createFileRoute } from '@tanstack/react-router';

import { TokensPage } from '@/features/tokens/tokens-page';

export const Route = createFileRoute('/admin/tokens/')({
  component: TokensPage,
});
